import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { db } from "../Firebase";
import { collection, getDocs } from "firebase/firestore";
import "./Login.css";

const Login = ({ onLoginSuccess }) => {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const [errors, setErrors] = useState({
    username: false,
    password: false,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loginStatus, setLoginStatus] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: false,
    });
    setLoginStatus("");
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const validate = () => {
    let isValid = true;
    const newErrors = { ...errors };

    if (!formData.username.trim()) {
      newErrors.username = true;
      isValid = false;
    }

    if (!formData.password.trim()) {
      newErrors.password = true;
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (validate()) {
      setLoginStatus("กำลังตรวจสอบ...");

      try {
        // ดึงข้อมูลผู้ใช้ทั้งหมดจากฐานข้อมูล
        const querySnapshot = await getDocs(collection(db, "assumption"));
        let loginSuccessful = false;
        let userDataFound = null;

        // ปรับข้อมูลที่ผู้ใช้กรอกให้เป็นมาตรฐาน (ไม่สนใจตัวพิมพ์ใหญ่-เล็กและช่องว่าง)
        const normalizedUsername = formData.username.trim().toLowerCase();
        const normalizedPassword = formData.password.trim().toLowerCase();

        // วนลูปตรวจสอบข้อมูลผู้ใช้ทั้งหมด
        querySnapshot.forEach((doc) => {
          const userData = doc.data();
          
          // ปรับข้อมูลในฐานข้อมูลให้เป็นมาตรฐาน (ไม่สนใจตัวพิมพ์ใหญ่-เล็กและช่องว่าง)
          const dbUsername = userData.username?.trim().toLowerCase() || '';
          const dbPassword = userData.password?.trim().toLowerCase() || '';
          
          // เปรียบเทียบข้อมูลที่ผ่านการ normalize แล้ว
          if (normalizedUsername === dbUsername && 
              normalizedPassword === dbPassword) {
            loginSuccessful = true;
            userDataFound = {
              username: userData.username, // เก็บค่าเดิมไม่แปลง
              level: userData.level || 0,
              score: userData.score || 0
            };
          }
        });

        if (loginSuccessful) {
          onLoginSuccess(userDataFound);
          navigate("/exercies"); // Redirect ไปหน้า Exercies
        } else {
          setLoginStatus("ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง");
        }

      } catch (error) {
        console.error("เกิดข้อผิดพลาดในการ Login:", error);
        setLoginStatus("เกิดข้อผิดพลาดในการเชื่อมต่อ");
      }
    } else {
      setLoginStatus("กรุณากรอกข้อมูลให้ครบถ้วน");
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-icon">
          <img src="/Wisdom-Logo.png" alt="User Icon" />
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          <h2>Student Login</h2>
          <div className={`input-group ${errors.username ? "alert-validate" : ""}`}>
            <input
              type="text"
              className="input100"
              name="username"
              placeholder="Username"
              value={formData.username}
              onChange={handleChange}
            />
          </div>
          <div className={`input-group ${errors.password ? "alert-validate" : ""}`}>
            <input
              type={showPassword ? "text" : "password"}
              className="input100"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
            />
            <span
              className="password-toggle"
              onClick={togglePasswordVisibility}
            >
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </span>
          </div>
          <button type="submit" className="login-button">
            Login
          </button>
          {loginStatus && (
            <div className="login-status" style={{ 
              color: loginStatus.includes("ไม่") ? "red" : "green",
              marginTop: "15px",
              textAlign: "center"
            }}>
              {loginStatus}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default Login;